/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wsc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free whitespace cleaner. Trim lines, collapse extra spaces, and remove blank lines from text. Runs in your browser.`)
};

const es_wsc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpiador de espacios en blanco gratuito. Recorta líneas, colapsa espacios adicionales y elimina líneas en blanco del texto. Se ejecuta en tu navegador.`)
};

const de_wsc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Leerzeichen-Bereiniger. Trimmen Sie Zeilen, fassen Sie überflüssige Leerzeichen zusammen und entfernen Sie Leerzeilen aus Text. Läuft in Ihrem Browser.`)
};

const nl_wsc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis witruimte opruimer. Trim regels, vouw extra spaties in en verwijder lege regels uit tekst. Werkt in uw browser.`)
};

const fr_wsc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nettoyeur d'espaces blancs gratuit. Supprimez les espaces de chaque ligne, réduisez les espaces supplémentaires et supprimez les lignes vides du texte. Fonctionne dans votre navigateur.`)
};

const it_wsc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulitore di spazi bianchi gratuito. Taglia le righe, comprimi gli spazi extra e rimuovi le righe vuote dal testo. Funziona nel tuo browser.`)
};

const pt_br2_wsc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpador de espaços em branco gratuito. Aparar linhas, colapsar espaços extras e remover linhas em branco do texto. Funciona no seu navegador.`)
};

const pt_wsc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpador de espaços em branco gratuito. Apare linhas, colapsar espaços extras e remova linhas em branco do texto. Funciona no seu navegador.`)
};

const ja_wsc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のホワイトスペースクリーナー。テキストから行をトリム、余分なスペースを圧縮し、空白行を削除します。ブラウザで実行されます。`)
};

const zh_wsc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的空白字符清理工具。修剪文本行、合并多余空格、删除空行。在您的浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wsc_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wsc_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wsc_tool_description", locale)
	if (locale === "en") return en_wsc_tool_description(inputs)
	if (locale === "es") return es_wsc_tool_description(inputs)
	if (locale === "de") return de_wsc_tool_description(inputs)
	if (locale === "nl") return nl_wsc_tool_description(inputs)
	if (locale === "fr") return fr_wsc_tool_description(inputs)
	if (locale === "it") return it_wsc_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_wsc_tool_description(inputs)
	if (locale === "pt") return pt_wsc_tool_description(inputs)
	if (locale === "ja") return ja_wsc_tool_description(inputs)
	return zh_wsc_tool_description(inputs)
};